import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

export class HttpMethods {
  constructor(
    private baseUrl: string,
    private http: HttpClient
  ) {}

  protected httpGet<T>(uri: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(this.baseUrl + uri, { params: params || null }).pipe(
      take(1),
      catchError(error => throwError(error.error))
    );
  }

  protected httpPost<T>(uri: string, data: T, options?: any): Observable<any> {
    return this.http.post(this.baseUrl + uri, data, options).pipe(
      take(1),
      catchError(error => throwError(error.error))
    );
  }

  protected httpDelete<T>(uri: string, options?: T): Observable<any> {
    return this.http.delete(this.baseUrl + uri, options).pipe(
      take(1),
      catchError(error => throwError(error.error))
    );
  }

  protected httpPut<T>(uri: string, data?: T, options?: any): Observable<any> {
    return this.http.put(this.baseUrl + uri, data, options).pipe(
      take(1),
      catchError(error => throwError(error.error))
    );
  }
}
